
import type {Session} from '@/api/Sessions'
import RadioGroup from '@/components/forms/RadioGroup.vue'
import type {AnnotatedSession} from '@/helpers/DynamicMessages'
import environment from '@/helpers/Environment'
import english from '@/language/en'
import Validation from '@/plugins/Validation'
import currencyFormatter from 'currency-formatter'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  name: 'SelectAvailableSession',
  components: { RadioGroup },

  // TODO Remove the validation mixin.
  mixins: [Validation],
})
export default class extends Vue {
  @Prop({ required: true })
  eventSessions: AnnotatedSession[]

  @Prop()
  value: Session

  @Prop()
  hideLabel: boolean

  t: typeof english.selectAvailableSession

  get selectedSessionId() {
    return this.value && this.value.id
  }

  get availableSessions(): RadioGroupOption[] {
    return this.eventSessions.map((session) => {
      const capacity = session.availableCapacity
      const threshold = environment.web.show_remaining_session_capacity_threshold ?? 0
      const showRemainingCapacity = capacity < threshold

      return {
        value: session.id,
        label: session.startMoment.format('h:mm'),
        labelSuffix: session.startMoment.format('A'),
        description: showRemainingCapacity ? `${capacity} remaining` : null,
        badges: this.getBadges(session),
      }
    })
  }

  getBadges(session: AnnotatedSession): Badge[] {
    const result: Badge[] = []

    if (session.priceIncrease && session.priceIncrease > 0) {
      result.push({
        symbol: currencyFormatter.findCurrency(environment.portal.default_currency_code)?.symbol,
        style: 'increase',
      })
    }

    for (const annotation of session.annotations) {
      result.push({
        style: annotation.style,
      })
    }

    return result
  }

  get label() {
    return this.hideLabel ? null : this.t.title
  }

  created() {
    // @ts-ignore TODO Prefer helper libraries over mixins.
    this.$on('validate', this.validate)
  }

  mounted() {
    const { floor } = Math

    // The DOM element wrapping the radio items.
    const el: HTMLElement = this.$refs.radioGroup['$el']

    // How many columns to show. Columns should be at least 100px wide.
    const columns = floor(el.getBoundingClientRect().width / 100)

    // How wide each column should be, including its margin/gutter. Percentage, rounded to 2dp.
    // TODO See if we can scale this back a bit without breaking any tenants.
    const width = floor(10000 / columns) / 100

    // Set the width as a CSS Custom Property.
    el.style.setProperty('--selectable-session-width', `${width}%`)
  }

  onChange(newId: string) {
    const session = this.eventSessions.find((session) => session.id === newId)
    this.$emit('input', session)
  }
}
